export default {
  id: 69,
  title: 'Target #69 - PushOwl',
  url: 'https://cssbattle.dev/play/69',
  colors: ['#191919', '#E08027'],
  solution:
    '<a a><a b><a c><a d><a e><style>body{background:#191919}a{position:fixed}a[a]{top:132;left:162;width:75;height:75;background:#E08027;transform:rotate(45deg)}a[b],a[c]{top:77;width:114;height:114;background:radial-gradient(#191919 44.5px,#E08027 45.5px)}a[b]{left:89;border-radius:0 50% 50% 50%}a[c]{right:89;border-radius:50% 0 50% 50%;box-shadow:0 0 0 10px #191919}a[d],a[e]{top:125;width:11.5;height:11.5;border:9px solid #E08027;border-radius:50%;clip-path:inset(0 0 15px 0)}a[d]{left:131}a[e]{left:239}</style>',
}
